import styled from 'styled-components'

export const OptionContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
  color: ${props => props.theme.colors.text.default};
`

export const TypeContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp4};

  svg {
    color: ${props => props.theme.colors.text.default};
  }

  :first-child {
    display: block;
  }
`
